import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import {
    FilterDataStatus,
    FilterModel,
    FilterOption,
    generateFilterPlaceholder$,
    MultiFilterModel,
    SearchFilterModel,
} from '@ui/shared/util-filter';
import { Observable } from 'rxjs';
import { BlueCityFilterDataService } from '../../services/blue-city-filter-data';
import { Result, ToResult } from '@team23/ts-result';
import { filterKeys } from '../../definitions/filter-keys';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-blue-city-filters',
    templateUrl: './blue-city-filters.component.html',
    styleUrls: ['./blue-city-filters.component.scss'],
    standalone: false,
})
export class BlueCityFiltersComponent {

    @Output()
    public readonly toggledFilters = new EventEmitter<boolean>();

    public readonly searchFilter: FilterModel;
    public readonly categoriesFilter: FilterModel;
    public readonly sponsorsFilter: FilterModel;

    public readonly categoriesOptions$: Observable<Result<Array<FilterOption>, FilterDataStatus>>;
    public readonly sponsorsOptions$: Observable<Result<Array<FilterOption>, FilterDataStatus>>;

    public readonly categoriesFilterPlaceholder$: Observable<string>;
    public readonly sponsorsFilterPlaceholder$: Observable<string>;

    public readonly filterOptionsFallback = ToResult.fromErrorKey(FilterDataStatus.Loading);

    constructor(
        private readonly _filterDataService: BlueCityFilterDataService,
    ) {
        this.categoriesOptions$ = _filterDataService.categoriesOptions$;
        this.sponsorsOptions$ = _filterDataService.sponsorsOptions$;

        this.searchFilter = new SearchFilterModel(filterKeys.textSearch, 'Suchbegriff', []);
        this.categoriesFilter = new MultiFilterModel(filterKeys.categories, 'Kategorien', []);
        this.sponsorsFilter = new MultiFilterModel(filterKeys.sponsors, 'Projektträger', []);

        this.categoriesFilterPlaceholder$ = generateFilterPlaceholder$(this.categoriesOptions$);
        this.sponsorsFilterPlaceholder$ = generateFilterPlaceholder$(this.sponsorsOptions$);
    }

    public reloadFilterOptions(): void {
        this._filterDataService.reloadErrored();
    }
}
